import { FC } from 'react'
import { Box, Flex } from '../atoms/Grid'
import { Rating } from 'react-simple-star-rating'
import { Body2, Body3 } from '../atoms/typography'
import styled from 'styled-components'
import { ProductRateData } from '@/network/graphql.g'
import { validFor } from '@/theme/validFor'

type ProductRateDataProps = {
  productRateData: ProductRateData
  hideRateCounts?: boolean
  size?: number
  marginTop?: number
  fillColor?: string
}

const RatingInfoIcon: FC<ProductRateDataProps> = ({
  productRateData,
  hideRateCounts,
  size,
  marginTop,
  fillColor
}) => {
  const { rateCounts, rateTotal } = productRateData ?? {}
  return (
    <StyledFlex flexDirection="row" alignItems="center" size={size}>
      <Box mt={marginTop ? `${marginTop}px` : 0}>
        <Rating
          readonly
          initialValue={rateTotal}
          allowFraction={true}
          size={size || 16}
          fillColor={fillColor}
        />
      </Box>
      <StyledBody2 m={0} size={size}>
        {rateTotal?.toFixed(1)}
      </StyledBody2>
      <StyledBody3 m={0} size={size} hideRateCounts={hideRateCounts}>
        ({rateCounts})
      </StyledBody3>
    </StyledFlex>
  )
}

export default RatingInfoIcon

const StyledFlex = styled(Flex)`
  gap: ${(props) => (props.size < 16 ? '5px' : '8px')};
`

const StyledBody2 = styled(Body2)`
  font-size: ${(props) => props.size && `${props.size}px`};
`

const StyledBody3 = styled(Body3)`
  opacity: 0.6;
  font-size: ${(props) => props.size && `${props.size}px`};
  ${validFor.mobile`
    display: ${(props) => (props.hideRateCounts ? 'none' : 'block')};
`};
`
